import { render, staticRenderFns } from "./BtnJustificativaDataVencimento.vue?vue&type=template&id=8419f22c"
import script from "./BtnJustificativaDataVencimento.vue?vue&type=script&lang=js"
export * from "./BtnJustificativaDataVencimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports